import { useEffect } from 'react';

import { resetGlobalState } from 'react-use-websocket';

import { Activity } from '@data';

import { useSocketConnection, useMessageHandler } from './hooks';

const HEARTBEAT_INTERVAL_MS = 5_000;

type MessageListenerProps = {
    currentActivity?: Activity | null;
    messageEndpoint: string;
    device: 'kiosk' | 'floor';
    onActivityIdChange: (activityId: number | null) => void;
};

export function MessageListener({
    currentActivity,
    messageEndpoint,
    device,
    onActivityIdChange,
}: MessageListenerProps) {
    const handleMessage = useMessageHandler({ currentActivity, onActivityIdChange });

    const { sendActivityId } = useSocketConnection({
        messageEndpoint: messageEndpoint,
        onMessage: handleMessage,
        device,
    });
    const currentActivityId = currentActivity?.id ?? null;

    // TODO: we will implement native WS ping/pong
    useEffect(() => {
        sendActivityId(currentActivityId);

        const interval = setInterval(() => {
            sendActivityId(currentActivityId);
        }, HEARTBEAT_INTERVAL_MS);

        return () => {
            clearInterval(interval);
            sendActivityId(null);
        };
    }, [currentActivityId, sendActivityId]);

    useEffect(() => {
        return () => {
            resetGlobalState(messageEndpoint);
        };
    }, [messageEndpoint]);

    return null;
}
